import React, { useState } from "react";
import { toast } from "sonner";
import { api, extractApiError } from "../../lib/api";
import { buildQuickNotePayload, normalizeQuickNoteDescription } from "../../lib/quick-note";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

export default function QuickNoteDialog({ open, onOpenChange, relationPayload, onCreated }) {
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => {
    setDescription("");
  };

  const handleOpenChange = (next) => {
    if (saving) return;
    if (!next) reset();
    onOpenChange(next);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;
    const trimmed = normalizeQuickNoteDescription(description);
    if (!trimmed) {
      toast.error("Bitte eine Notiz eingeben.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/api/activities", buildQuickNotePayload({ description: trimmed, relationPayload }));
      toast.success("Notiz hinzugefügt");
      handleOpenChange(false);
      if (onCreated) onCreated();
    } catch (err) {
      toast.error(extractApiError(err, "Notiz konnte nicht gespeichert werden."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Notiz hinzufügen</DialogTitle>
          <DialogDescription>Erfasse eine kurze Notiz zu diesem Datensatz.</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="quick-note-description">Notiz</Label>
            <Textarea
              id="quick-note-description"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Kurze Notiz eingeben …"
              disabled={saving}
              autoFocus
            />
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => handleOpenChange(false)} disabled={saving}>
              Abbrechen
            </Button>
            <Button type="submit" disabled={saving}>
              {saving ? "Speichern …" : "Notiz speichern"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

